module.exports = "/packs/images/components/search/ku-listview~e0bf70ce7f7bf10e94197b0d05a42056.png";